import { SET_MOCK_DATA, SHOW_MOCK_DIALOG, HIDE_MOCK_DIALOG } from './actions.js';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const initialState = {
  mockData: {
    method: null,
    path: null,
    example: null,
  },
  showDialog: false,
};

const reducers = {
  [SET_MOCK_DATA]: (state, action) => {
    return state.set('mockData', action.payload);
  },
  [SHOW_MOCK_DIALOG]: (state) => {
    return state.set('showDialog', true);
  },
  [HIDE_MOCK_DIALOG]: (state) => {
    return state.set('showDialog', false);
  },
};

export default reducers;
